import { useQuery } from '@apollo/client'
import { useOptionalWaveId } from '../../../hooks/useOptionalWaveId'
import { useProjectId } from '../../../hooks/useProjectId'
import { useSurveyId } from '../../../hooks/useSurveyId'
import { LOOPING_DATA } from '../../Audience/AudienceQuestionCardFooter/LoopingData.questionnaire.gql'

// @todo return a discriminated union for entry.entryType/entry.entryItem
export const useQuestionnaireSectionsLoopingData = () => {
  const projectId = useProjectId()
  const surveyId = useSurveyId()
  const waveId = useOptionalWaveId()
  const { data: loopingData } = useQuery(LOOPING_DATA, {
    context: { clientName: 'questionnaire' },
    variables: {
      projectId,
      surveyId,
      waveId
    },
    skip: !surveyId
  })

  return loopingData?.draftQuestionnaire?.entries ?? []
}
